import { useTheme } from "@emotion/react";
import React from "react";
import { IconType } from "react-icons/lib";
import { MdDownload, MdUpload } from "react-icons/md";

import { DiffSyncDirection } from "./types";

export const DiffTabs = (props: {
  activeTab: DiffSyncDirection;
  directionLabels: Record<DiffSyncDirection, string>;
  pullCount: number | undefined;
  pushCount: number | undefined;
  onChange: (tab: DiffSyncDirection) => void;
}) => {
  const theme = useTheme();

  return (
    <div
      css={{
        display: "grid",
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        gap: "0.5rem",
        width: "100%",
        padding: "0.25rem",
        border: `1px solid ${theme.colors.primaryLight}`,
        borderRadius: theme.smallBorderRadius,
        background: "white",
      }}
    >
      <DiffTab
        isActive={props.activeTab === "pull"}
        label={props.directionLabels.pull}
        count={props.pullCount}
        Icon={MdDownload}
        onClick={() => props.onChange("pull")}
      />
      <DiffTab
        isActive={props.activeTab === "push"}
        label={props.directionLabels.push}
        count={props.pushCount}
        Icon={MdUpload}
        onClick={() => props.onChange("push")}
      />
    </div>
  );
};

const DiffTab = (props: {
  isActive: boolean;
  label: string;
  count: number | undefined;
  Icon: IconType;
  onClick: () => void;
}) => {
  const theme = useTheme();
  const Icon = props.Icon;

  return (
    <button
      onClick={props.onClick}
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.75rem",
        width: "100%",
        minWidth: 0,
        padding: "0.75rem 1rem",
        border: "none",
        borderRadius: theme.smallBorderRadius,
        background: props.isActive ? theme.colors.background : "transparent",
        color: theme.colors.primary,
        cursor: "pointer",
        fontSize: "0.9375rem",
        transition: "background 0.1s ease-in-out",
      }}
    >
      <span css={{ display: "flex", alignItems: "center", gap: "0.5rem", fontWeight: props.isActive ? 700 : 400 }}>
        <Icon size={18} />
        {props.label}
      </span>
      <span
        css={{
          minWidth: "2rem",
          padding: "0.125rem 0.5rem",
          borderRadius: "999px",
          background: props.isActive ? theme.colors.primary : theme.colors.primaryLight,
          color: props.isActive ? "white" : theme.colors.primary,
          fontWeight: 700,
          fontSize: "0.8125rem",
          textAlign: "center",
        }}
      >
        {props.count ?? "-"}
      </span>
    </button>
  );
};
